import { PermissionGuard } from '@shared/permissions';
import { APP_PERMISSIONS } from '@user-management/permissions';
import { RoleManagementModalProvider } from '@user-management/role-management';
import { Outlet } from 'react-router-dom';

export default function RoleAndPermissionLayout() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.SETTING.ROLE.VIEW]}>
      <RoleManagementModalProvider>
        <Outlet />
      </RoleManagementModalProvider>
    </PermissionGuard>
  );
}
